export default "__VITE_ASSET__CwyBWq8Y__"